import { useAccountIbansApi } from '../api';

export const useAccountIbans = () => {
  const response = useAccountIbansApi({});
  return response;
};
